export const sectionPins = {
  /**
   * Homepage
   */
  featured: {
    clipStyle: 'reveal',
    bufferStart: 1,
    bufferEnd: 0,
    noBottomCrop: true,
  },
  mission: {
    clipStyle: 'reveal',
    bufferStart: 0,
    bufferEnd: 0,
    preroll: 0.5,
    postroll: 0.25,
    reveal: ({
      pixelProgress,
      windowHeight,
      sectionHeight,
      direction,
      progress,
    }) => {
      return (
        // start
        (direction >= 0
          ? pixelProgress >= windowHeight * 0.25
          : pixelProgress >= 100) &&
        // end
        pixelProgress < sectionHeight
      )
    },

    noBottomCrop: true,
  },
  train: {
    clipStyle: 'reveal',
    bufferStart: 1,
    bufferEnd: 1,
    noBottomCrop: true,
  },
  'overview-effect': {
    clipStyle: 'reveal',
    bufferStart: 1,
    bufferEnd: 1,
  },
  'mechanics-and-tech': {
    // sticky-fade
    clipStyle: 'sticky-fade',
    bufferStart: 2,
  },
  station: {
    // sticky-fade
    clipStyle: 'sticky-fade',
    bufferStart: 2,
  },
  coda: {
    // sticky-fade
    reveal: ({ progress, pixelProgress, sectionHeight, windowHeight }) => {
      return progress > 0.56 && pixelProgress < sectionHeight - windowHeight
    },
    clipStyle: 'sticky-fade',
    bufferStart: 4,
    noBottomPin: true,
    noBottomCrop: true,
  },

  /**
   * Fleet
   */
  'vms-eve': {
    clipStyle: 'sticky-fade',
    bufferStart: 4,
  },
  'vss-unity': {
    clipStyle: 'sticky-fade',
    bufferStart: 4,
  },
  'meet-our-pilots': {
    clipStyle: 'sticky-fade',
    bufferStart: 4,
  },
  'feather-technology': {
    clipStyle: 'sticky-fade',
    bufferStart: 4,
  },
  'unity-interior-tech': {
    clipStyle: 'reveal',
    bufferStart: 1,
    bufferEnd: 1,
    noBottomCrop: true,
  },
  'unity-interior': {
    clipStyle: 'reveal',
    bufferStart: 1,
    bufferEnd: 1,
    noBottomCrop: true,
  },
  'spaceflight-with-virgin-galactic': {
    clipStyle: 'reveal',
    bufferStart: 1,
    bufferEnd: 1,
    noBottomCrop: true,
  },
  'fleet-coda': {
    clipStyle: 'reveal',
    bufferStart: 4,
    noBottomPin: true,
    noBottomCrop: true,
  },

  /**
   * Spaceport
   */
  'preflight-training-program': {
    clipStyle: 'reveal',
    preroll: 0.25,
    postroll: 0.25,
    reveal: ({
      pixelProgress,
      windowHeight,
      sectionHeight,
      direction,
      progress,
    }) => {
      return (
        // start
        (direction >= 0
          ? pixelProgress >= windowHeight * 0.25
          : pixelProgress >= 100) &&
        // end
        pixelProgress < sectionHeight
      )
    },
  },
  experience: {
    clipStyle: 'reveal',
    preroll: 0.25,
    noBottomPin: true,
    noBottomCrop: true,
  },
  hotspots: {
    clipStyle: 'sticky-fade',
    bufferStart: 5,
    noBottomPin: true,
    noBottomCrop: true,
  },

  /**
   * Flight Experience
   */
  community: {
    clipStyle: 'reveal',
    noBottomCrop: true,
    preroll: 0.25,
    postroll: 0.25,
  },
  package: {
    clipStyle: 'reveal',
    // bufferStart: 1,
    // bufferEnd: 1,
    preroll: 0.25,
    postroll: 0.25,
    noBottomCrop: true,
  },
  'zero-gravity': {
    clipStyle: 'reveal',
    // bufferStart: 0.5,
    preroll: 0.25,
    noBottomPin: true,
    noBottomCrop: true,
  },
}
